/**
 * True when a form's submit came from the form itself, not from a form drawn
 * inside it. A pop-up opened from inside a screen that is a form (the
 * delivery screen) has its own form; React still passes that form's submit up
 * to the screen's form, so the screen saved itself when someone created a
 * partner or a product from a pop-up (seen on the HMS and IMT test systems,
 * 2026-10-20). Clicks on the screen's own Save buttons and direct calls are
 * not submit events and always count.
 */
export const isOwnSubmit = (e) => !(e && e.type === 'submit' && e.target !== e.currentTarget);
